import { useRef, useState, useContext } from 'react';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
import { useSnackbar } from 'src/components/snackbar';
import { Box } from '@mui/material';

// import { useMockedUser } from 'src/hooks/use-mocked-user';

import Iconify from 'src/components/iconify';
import { Tooltip } from '@mui/material';
import { TokenContext } from '../../context/TokenContext';

// ----------------------------------------------------------------------

export default function KanbanDetailsCommentInput({ handleComment }) {
  // const { user } = useMockedUser();
  const { enqueueSnackbar } = useSnackbar();
  const [commentText, setCommentText] = useState('');
  const fileRef = useRef(null);
  const [file, setFile] = useState(null);
  const { token, decodedToken } = useContext(TokenContext);

  const { role, userName, email, profileUrl } = decodedToken;
  const handleClick = () => {
    if (commentText) {
      return enqueueSnackbar("Only one input is allowed at a time. Please remove either the text message or the selected file before sending.", {
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
        variant: "error"
      });
    }
    fileRef.current.click();
  };

  const fileChange = (file) => {
    const validImageType = ['image/jpg', 'image/png', 'image/jpeg'];
    if (!file) {
      return setFile(null);
    }
    if (!validImageType.includes(file.type)) {
      return enqueueSnackbar('Invalid image Type.', {
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
        variant: 'error',
      });
    }
    setFile(file);
    enqueueSnackbar(`${file.name} selected successfully`, {
      anchorOrigin: { vertical: 'top', horizontal: 'right' },
    });
  };

  const handleSubmit = () => {
    if (!commentText && !file) {
      return enqueueSnackbar('Invalid comment input.', {
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
        variant: 'error',
      });
    }
    if (commentText) {
      handleComment('text', commentText);
      setCommentText('');
      return;
    }
    if (file) {
      handleComment('image', file);
      setCommentText('');
      setFile(null);
    }
  };

  const handleTextChange = (value) => {
    if (file) {
      return enqueueSnackbar(
        'Only one input is allowed at a time. Please remove either the text message or the selected file before sending.',
        {
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
          variant: 'error',
        }
      );
    }
    setCommentText(value);
  };

  const handleFileClose = () => {
    setFile(null);
  }

  const user = {
    "id": email,
    "displayName": userName,
    "email": email,
    "password": "demo1234",
    "photoURL": profileUrl,
    "phoneNumber": "+91 ",
    "country": "India",
    "address": "Jaipur",
    "state": "Rajasthan",
    "city": "Jaipur",
    "zipCode": "302022",
    "about": "Praesent turpis. Phasellus viverra nulla ut metus varius laoreet. Phasellus tempus.",
    "role": role,
    "isPublic": true
  }

  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        py: 3,
        px: 2.5,
      }}
    >
      <Avatar src={user?.photoURL} alt={user?.displayName}>
        {user?.displayName?.charAt(0).toUpperCase()}
      </Avatar>

      <Paper variant="outlined" sx={{ p: 1, flexGrow: 1, bgcolor: 'transparent' }}>
        <InputBase
          fullWidth
          multiline
          rows={2}
          placeholder="Type a message"
          sx={{ px: 1 }}
          value={commentText}
          onChange={(e) => handleTextChange(e.target.value)}
        />

        {file && (
          <Box sx={{ px: 1, py: 1 }}>
            <Box sx={{ position: 'relative', display: 'inline-block' }}>
              <img
                src={URL.createObjectURL(file)}
                alt="preview"
                style={{
                  width: 80,
                  height: 80,
                  objectFit: 'cover',
                  borderRadius: 8,
                  border: '1px solid #ccc',
                }}
              />
              <IconButton
                size="small"
                onClick={handleFileClose}
                sx={{
                  position: 'absolute',
                  top: -8,
                  right: -8,
                  bgcolor: 'background.paper',
                  boxShadow: 1,
                  width: 24,
                  height: 24,
                  p: 0.5,
                  zIndex: 1,
                }}
              >
                <Iconify icon="carbon:close-outline" />
              </IconButton>
            </Box>
          </Box>
        )}

        <Stack direction="row" alignItems="center">
          <Stack direction="row" flexGrow={1}>
            {!file && (
              <Tooltip title="Select image.">
                <IconButton onClick={handleClick}>
                  <Iconify icon="solar:gallery-add-bold" />
                </IconButton>
              </Tooltip>
            )}

            <input type="file" ref={fileRef} accept="image/*" onChange={(e) => fileChange(e.target.files[0])} hidden />
          </Stack>

          <Button variant="contained" onClick={handleSubmit}>
            Comment
          </Button>
        </Stack>
      </Paper>
    </Stack>
  );
}
